import { render, staticRenderFns } from "./SectionClientSlider.vue?vue&type=template&id=26dc64e6&"
import script from "./SectionClientSlider.vue?vue&type=script&lang=js&"
export * from "./SectionClientSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LogoSlider: require('/builds/marketing/abstracta.academy-website/components/LogoSlider.vue').default})
